import { useMemo } from 'react';
import { useHttpClient } from '../../client/HttpClientContext';
import { getPropertyInputComponent } from '../utils/getPropertyInputComponent';
import { useGetAdditionalPropertyValue } from './useGetAdditionalPropertyValue';
import { useInternalPropertyValue } from './useInternalPropertyValue';
import { useObjectId } from './useObjectId';
import { useObjectTypeId } from './useObjectTypeId';
import { usePropertyAccessLevel } from './usePropertyAccessLevel';
import { useProperty } from './useProperty';
import { useGetIsUngated } from './useGetIsUngated';
import useOptionColors from '../../input/select/useOptionColors';
import { useAIProcessingStatusWithMetadata } from '../../ai/useAIProcessingStatusWithMetadata';
export const usePropertyInputComponent = ({
  isHidingHighlySensitiveValue,
  isPropertyReadOnly,
  enableMultipleEmailInput,
  enablePopovers,
  enableCheckboxInput,
  enablePhoneNumberInput,
  use = 'default'
}) => {
  const accessLevel = usePropertyAccessLevel();
  const objectTypeId = useObjectTypeId();
  const property = useProperty();
  const objectId = useObjectId();
  const getAdditionalPropertyValue = useGetAdditionalPropertyValue();
  const getIsUngated = useGetIsUngated();
  const httpClient = useHttpClient();
  const internalValue = useInternalPropertyValue();
  const {
    shouldUseOptionColors
  } = useOptionColors();
  const {
    status: aiProcessingStatus
  } = useAIProcessingStatusWithMetadata(objectTypeId, property.name, objectId);
  return useMemo(() => {
    return getPropertyInputComponent({
      accessLevel,
      enableMultipleEmailInput,
      enablePopovers,
      enableCheckboxInput,
      enablePhoneNumberInput,
      use,
      getAdditionalPropertyValue,
      getIsUngated,
      httpClient,
      isHidingHighlySensitiveValue,
      objectTypeId,
      property,
      objectId,
      // We need the raw property value here because some external options
      // components need the raw value of the property to determine the reference
      // type of the property.
      //
      // A specific example of this are Analytics Source properties which can have
      // a value shaped `userId:123` that will usually get parsed into `123` in
      // usePropertyValue but for the purpose of this logic we need the raw value
      // to know it's a user property
      propertyValue: internalValue,
      readOnly: isPropertyReadOnly,
      shouldUseOptionColors,
      aiProcessingStatus
    });
  }, [accessLevel, enableMultipleEmailInput, enablePopovers, enableCheckboxInput, enablePhoneNumberInput, use, getAdditionalPropertyValue, getIsUngated, httpClient, isHidingHighlySensitiveValue, objectTypeId, property, objectId, internalValue, isPropertyReadOnly, shouldUseOptionColors, aiProcessingStatus]);
};